export const connectorQueueSchema = {
    type: 'object',
    properties: {
        localhost: { type: 'string' },
        dev: { type: 'string' },
        prod: { type: 'string' },
        uat: { type: 'string' },
    },
};
